import * as React from 'react'
import * as ReactDOM from 'react-dom'
import * as JQueryStatic from 'jquery'
import {MemoryFolder, MemoryFile, DeleteCallback} from "./Types";

interface MemoryFileRowProps extends React.Props<FileComponent> {
	file:MemoryFile;
	deleteIconPath?:string;
	deleteCallback?:DeleteCallback;
}

abstract class FileOrFolderComponent extends React.Component<MemoryFileRowProps, {}> {
	render() {
		const {deleteCallback} = this.props
		const deleteButton = (deleteCallback === undefined || this.props.deleteIconPath === undefined) ? null : (
			<span className="delete">
				<a href="#" onClick={(event) => { deleteCallback(this.props.file.id); event.preventDefault() }}>
					<img src={this.props.deleteIconPath} />
				</a>
			</span>
		);

		const type = this.type();

		return <li className={`${type}-details details`}>
			<span className={`${type} item`}>
				<span className={`${type}-icon icon`}>
					{this.icon()}
				</span>
				<span className={`${type}-label label`}>
					{this.title()}
					{this.titleSuffix()}
				</span>
			</span>
			{deleteButton}
		</li>
	}

	private icon() {
		return this.maybeLink(<img src={this.props.file.iconPath} />)
	}

	private title() {
		return this.maybeLink(<span>{this.props.file.title}</span>)
	}

	private maybeLink(child:JSX.Element) {
		const link = this.props.file.link
		return link != null ? <a href={link}>{child}</a> : child
	}

	protected titleSuffix():JSX.Element|null {
		return null
	}

	protected abstract type():string
}

export class FileComponent extends FileOrFolderComponent {
	protected titleSuffix():JSX.Element {
		return <span>{' ('}{this.props.file.size}{')'}</span>
	}

	protected type():string {
		return 'file';
	}
}

export class FolderComponent extends FileOrFolderComponent {
	protected type():string {
		return 'folder';
	}
}

interface RecursiveCategoryTreeProps extends React.Props<RecursiveFolderTree> {
	parentId:number;
	allPotentialChildren:MemoryFolder[];
	directoryIconPath:string;
}

export class RecursiveFolderTree extends React.Component<RecursiveCategoryTreeProps, {}> {

	render() {
		const children = this.props.allPotentialChildren.filter((child) => child.parent_serial == this.props.parentId);

		const otherItems:JSX.Element[] = children.map((item) => {
			const key = `category-tree-entry-${item.id}`;
			return item.is_directory ?
				<CategoryRow
					key={key}
					category={item}
					directoryIconPath={this.props.directoryIconPath}
					allPotentialChildren={this.props.allPotentialChildren} /> :
				<FileComponent key={key} file={item} />;
		});

		return <ul className="child-list item-list">
			{otherItems}
		</ul>
	}

}

interface CategoryRowProps extends React.Props<CategoryRow> {
	category:MemoryFolder;
	allPotentialChildren:MemoryFolder[];
	directoryIconPath:string;
}

class CategoryRow extends React.Component<CategoryRowProps, {}> {
	render() {
		return <li className="category-details details">
			<div>
				<span className="category item">
					<span className="category-icon icon">
						<img src={this.props.directoryIconPath} />
					</span>
					<span className="category-label label">
						{this.props.category.title}
					</span>
				</span>
			</div>
			<RecursiveFolderTree
				parentId={this.props.category.id}
				directoryIconPath={this.props.directoryIconPath}
				allPotentialChildren={this.props.allPotentialChildren} />
		</li>
	}
}



// WEBPACK FOOTER //
// ./src/memory/component/Component.tsx